export default __webpack_public_path__ + "static/media/desktop.e53f534f.svg";